// isTwelveHourTime
export default (function (groups) {
  return (/[a-z]/i.test(groups[groups.length - 1])
  );
});


// WEBPACK FOOTER //
// ./dist/lib/is-twelve-hour-time.js